import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[workflowWrappedControlHost]',
    standalone: false,
})
export class WorkflowWrappedControlDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
